// src/pages/PainelChamados/FormularioEditarChamado.jsx
import { X, ClipboardList } from "lucide-react";
import CamposFormulario from "./CamposFormulario";
import CampoEmpresa from "./CampoEmpresa";
import CampoResponsavel from "./CampoResponsavel";
import CampoRelatoSolucao from "./CampoRelatoSolucao";
import MenuEditar from "./MenuEditar"; // 🔹 usa o menu correto

import { useState, useEffect } from "react";

export default function FormularioEditarChamado({ chamado, onVoltar, onSalvo }) {
  // 🔹 Estados preenchidos com os dados do chamado
  const [filtroCliente, setFiltroCliente] = useState("");
  const [colaborador, setColaborador] = useState("");
  const [tecnicoResponsavel, setTecnicoResponsavel] = useState("");
  const [relatoProblema, setRelatoProblema] = useState("");
  const [solucaoProblema, setSolucaoProblema] = useState("");
  const [status, setStatus] = useState("");
  const [tipoServico, setTipoServico] = useState("");
  const [finalizadoEm, setFinalizadoEm] = useState("");

  // 🔹 Preenche os estados quando o chamado mudar
  useEffect(() => {
    if (chamado) {
      setFiltroCliente(chamado.empresa || "");
      setColaborador(chamado.colaborador || "");
      setTecnicoResponsavel(chamado.tecnico_responsavel || "");
      setRelatoProblema(chamado.relato_problema || "");
      setSolucaoProblema(chamado.solucao_problema || "");
      setStatus(chamado.status || "Aberto");
      setTipoServico(chamado.tipo_servico || "");
      setFinalizadoEm(chamado.finalizado_em || "");
    }
  }, [chamado]);

  return (
    <div
      className="bg-white rounded-md shadow-sm h-full flex flex-col"
      style={{ border: "1px solid #2b2b2b" }}
    >
      {/* Cabeçalho */}
      <div
        className="flex items-center justify-between px-4 py-3"
        style={{ backgroundColor: "#2b2b2b" }}
      >
        <div className="flex items-center gap-2">
          <ClipboardList size={20} className="text-white" />
          <h2 className="text-lg font-semibold text-white">
            Editando chamado #{chamado?.id}
          </h2>
        </div>
        <button
          onClick={onVoltar}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-white text-black transition transform hover:scale-110 hover:bg-slate-200"
          aria-label="Fechar formulário"
        >
          <X size={16} />
        </button>
      </div>

      {/* Conteúdo */}
      <div className="flex flex-1 overflow-hidden">
        {/* Formulário */}
        <div className="flex-1 p-6 overflow-y-auto space-y-6">
          <CamposFormulario
            tipoServico={tipoServico}
            setTipoServico={setTipoServico}
            finalizadoEm={finalizadoEm}
            setFinalizadoEm={setFinalizadoEm}
          />

          <div className="flex flex-wrap gap-6 mb-6 mt-4">
            <CampoEmpresa
              filtroCliente={filtroCliente}
              setFiltroCliente={setFiltroCliente}
            />

            <CampoResponsavel
              colaborador={colaborador}
              setColaborador={setColaborador}
              tecnicoResponsavel={tecnicoResponsavel}
              setTecnicoResponsavel={setTecnicoResponsavel}
            />
          </div>

          <CampoRelatoSolucao
            relato={relatoProblema}
            setRelato={setRelatoProblema}
            solucao={solucaoProblema}
            setSolucao={setSolucaoProblema}
          />
        </div>

        {/* Menu lateral para edição */}
        <div className="w-40 border-l border-slate-300 bg-gray-50 flex flex-col p-4">
          <MenuEditar
            chamadoSelecionado={chamado} // 🔹 passa o chamado atual
            colaborador={colaborador}
            tecnicoResponsavel={tecnicoResponsavel}
            relatoProblema={relatoProblema}
            solucaoProblema={solucaoProblema}
            filtroCliente={filtroCliente}
            status={status}
            tipoServico={tipoServico}
            setStatus={setStatus}
            finalizadoEm={finalizadoEm}
            setFinalizadoEm={setFinalizadoEm}
            onCancelar={onVoltar}
            onSalvo={onSalvo}
          />
        </div>
      </div>
    </div>
  );
}
